import React, { useState } from "react";
import { Modal, Button, Grid, Typography, SvgIcon } from "@material-ui/core";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useStyles } from "./InvoiceModal.styles";
import Loader from "common/Loader";
import IconButton from '@material-ui/core/IconButton';
import closeButton from "./../assets/icons/close-circle-icon.svg";
import { ReactComponent as zoomInIcon } from "./../assets/icons/zoom-in.svg";
import { ReactComponent as zoomOutIcon } from "./../assets/icons/zoom-out.svg";
import CloseIcon from '@material-ui/icons/Close';
import { TextConstants } from "constants/TextConstants";
interface InvoiceModalProps {
  consignmentCode: string;
  open: boolean;
  loading: boolean;
  displayInvoice: boolean;
  invoiceData: any;
  invoiceUrl?: string | null;
  numPages: number | null;
  onClose: () => void;
  onDownload?: () => void;
  onDocumentLoadSuccess: (numPages: number) => void;
}

const InvoiceModal: React.FC<InvoiceModalProps> = ({
  consignmentCode,
  open,
  loading,
  displayInvoice,
  invoiceData,
  invoiceUrl,
  numPages,
  onClose,
  onDownload,
  onDocumentLoadSuccess,
}) => {
  const classes = useStyles();
  const [scale, setScale] = useState(1);
  const [scaleNumber, setScaleNumber] = useState(100);

  const zoomIn = (scaleNumber: any) => {
    setScaleNumber(scaleNumber + 15);
    setScale(scale + 0.4);
  };

  const zoomOut = (scaleNumber: any) => {
    if (scale > 1) {
      setScaleNumber(scaleNumber - 15);
      setScale(scale - 0.4);
    } else {
      setScale(1);
    }
  };
  return (
    <Modal open={open} onClose={onClose}>
      <>
        {loading && <Loader />}
        {!loading && displayInvoice && (
          <>
            <Grid
              container
              justify="center"
              className={classes.downloadInvoice}
            >
              <Button variant="contained" color="primary" onClick={onDownload}>
                {TextConstants.DOWNLOAD_PDF}
              </Button>
            </Grid>
            <Grid container className={classes.pdfHeader}>
              <Grid item xs={3} className={classes.pdfRoot}>
                <Typography className={classes.pdfName}>
                  <Typography className={classes.pdfName}>
                    {consignmentCode}.pdf ({numPages} Pages)
                  </Typography>
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.pdfRoot}>
                <SvgIcon
                  component={zoomOutIcon}
                  className={classes.zoomOutStyle}
                  onClick={() => zoomOut(scaleNumber)}
                />
                <Typography className={classes.pdfScaleNo}>
                  {scaleNumber}
                </Typography>
                <SvgIcon
                  component={zoomInIcon}
                  className={classes.zoomInStyle}
                  onClick={() => zoomIn(scaleNumber)}
                />
              </Grid>
              <Grid item xs={3} className={classes.closeModalIcon}>
                <img
                  src={closeButton}
                  alt={TextConstants.MODAL_CLOSE_BUTTON}
                  onClick={onClose}
                  role="button"
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") {
                      onClose();
                    }
                  }}
                />
              </Grid>
            </Grid>
            <div className={classes.invoiceModalBody}>
              <div
                style={{
                  overflow: "scroll",
                  maxHeight: "920px",
                  height: "100%",
                }}
              >
                <Document
                  file={invoiceUrl ? { url: invoiceUrl } : invoiceData}
                  onLoadSuccess={({ numPages }: { numPages: number }) => {
                    onDocumentLoadSuccess(numPages);
                  }}
                  noData={TextConstants.NO_DATA}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      scale={scale}
                    />
                  ))}
                </Document>
              </div>
            </div>
          </>
        )}
        {!loading && !displayInvoice && (
          <Grid className={classes.noPdfModal}>
            <Grid
              style={{ overflow: "scroll", maxHeight: "890px", height: "100%" }}
            >
              <Grid
                className={classes.closeNoPdfModalIcon}
                onClick={onClose}
              >
                <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={onClose}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid className={classes.noInvoiceMsg}>
                {TextConstants.NO_INVOICE}
              </Grid>
            </Grid>
          </Grid>
        )}
      </>
    </Modal>
  );
};

export default InvoiceModal;
